import { useMemo } from "react"

import { ContentTag, Obj } from "scrivito"
import { ProductObj } from "scrivito/Objs/Product/ProductObjClass"
import { getCurrentSiteID } from "shared/lib/getCurrentSiteID"
import { SelectOption } from "shared/types/Select"

export function useProductOptions() {
  const productObjs: ProductObj[] | undefined = Obj.onSite(getCurrentSiteID())
    .where("_objClass", "equals", "Product")
    .and("isHiddenInPortfolio", "equals", false)
    .toArray() as ProductObj[]

  const options: SelectOption<string, ProductObj>[] = useMemo(
    () =>
      productObjs
        ?.map(product => ({
          value: product.get("productType"),
          label: (product.get("title") as string) || "",
          data: product,
          image: (
            <ContentTag alt="" content={product} attribute="imageWidgets" />
          )
        }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [productObjs]
  )

  return { productObjs, options, isLoading: !options || options.length === 0 }
}
